export type HelpdeskTicketStatus = 'OPEN' | 'IN_PROGRESS' | 'RESOLVED' | 'CLOSED';
export type HelpdeskTicketPriority = 'LOW' | 'NORMAL' | 'HIGH';

export const HELPDESK_TOOLS = [
  'consultar_ticket',
  'cerrar_ticket',
  'derivar_humano',
] as const;

export type HelpdeskToolName = (typeof HELPDESK_TOOLS)[number];

export const HELPDESK_TOOL_LABELS: Record<HelpdeskToolName, string> = {
  consultar_ticket: 'Consultar ticket',
  cerrar_ticket: 'Cerrar ticket',
  derivar_humano: 'Derivar a humano',
};

export const HELPDESK_TOOL_DESCRIPTIONS: Record<HelpdeskToolName, string> = {
  consultar_ticket: 'Lee el ticket abierto de la conversación y devuelve número y estado.',
  cerrar_ticket: 'Cierra el ticket y restablece el bot para atención automática.',
  derivar_humano: 'Escala la conversación a un operador humano y avisa al roster.',
};

export interface HelpdeskTicketSummary {
  id: string;
  number: number;
  status: HelpdeskTicketStatus;
  priority: HelpdeskTicketPriority;
  botId: string;
  botName?: string;
  conversationId: string;
  closedAt: string | null;
  createdAt: string;
  updatedAt: string;
}

export interface HelpdeskAgentRecord {
  id: string;
  tenantId: string;
  botId: string;
  domain: 'HELPDESK';
  name: string;
  objective: string | null;
  toolsEnabled: string[];
  createdAt: string;
  updatedAt: string;
  bot?: { id: string; name: string; systemPrompt?: string | null };
}

export interface HelpdeskAvailableBot {
  botId: string;
  name: string;
  systemPrompt: string;
}

export interface HelpdeskTelegramGroupInput {
  chatId: string;
  label: string;
}

export interface HelpdeskEscalationRoster {
  agentId: string;
  userIds: number[];
  telegramGroups: HelpdeskTelegramGroupInput[];
}

export interface HelpdeskRosterCandidate {
  id: number;
  name: string;
  role: string;
  hasTelegram: boolean;
}

export interface HelpdeskStats {
  open: number;
  inProgress: number;
  resolved: number;
  closed: number;
  byBot: Record<string, { open: number; inProgress: number; resolved: number; closed: number }>;
}

export interface CreateHelpdeskAgentRequest {
  botId: string;
  name: string;
  objective?: string;
  toolsEnabled?: string[];
  systemPrompt?: string;
}

export interface UpdateHelpdeskAgentRequest {
  name?: string;
  objective?: string;
  toolsEnabled?: string[];
  systemPrompt?: string;
}

export interface ReplaceHelpdeskRosterRequest {
  userIds: number[];
  telegramGroups: HelpdeskTelegramGroupInput[];
}

export const HELPDESK_LIMITS = {
  maxRosterMembers: 20,
  maxTelegramGroups: 10,
  groupLabelMax: 80,
  chatIdMax: 20,
  subjectMax: 200,
} as const;
